<template>
<div id="dynamic-component-demo" class="mt-20 mx-auto text-center  md:mt-24">
  <h2 class="mx-8 uppercase text-primary my-4 text-xl md:text-2xl">Administrar nuevos productos</h2>
  <div class="flex flex-row items-center justify-center">
      <router-link to="/SaludLista" tag="button" class="hidden md:block tab-button focus:outline-none">
          <p class="text-primary">
          Listado de productos de Salud
          </p>
      </router-link>
  </div>
  <button
    class="focus:outline-none mx-2 my-auto"
    v-for="tab in tabs"
    v-bind:key="tab"
    v-bind:class="['tab-button', { active: currentTab === tab }]"
    v-on:click="currentTab = tab"
  ><p class="text-primary">{{ tab }}</p></button>
  <component
    v-bind:is="currentTabComponent"
    class="tab"
  ></component>
</div>
</template>
<script>
import Carousel from '@/components/admin/carousel-admin.vue'
import Vestidos from '@/components/admin/dress-admin.vue'
import Complementos from '@/components/admin/complementos.vue'
import Accesorios from '@/components/admin/accesorios.vue'
import Salud from '@/components/admin/salud.vue'
import Belleza from '@/components/admin/belleza.vue'
import Eventos from '@/components/admin/eventos.vue'
import Tacones from '@/components/admin/tacones.vue'
import { mapGetters } from 'vuex'
export default {
    components: {
        Carousel,
        Vestidos,
        Complementos,
        Accesorios,
        Salud,
        Belleza,
        Eventos,
        Tacones
    },
    data() {
        return {
            currentTab: 'Carousel',
            tabs: ['Vestidos', 'Carousel','Complementos','Accesorios','Salud','Belleza','Eventos','Tacones']
        }
    },
    computed: {
        ...mapGetters([
            'loggedIn',
            'getprogress'
            ]),
        autenticado(){
            return this.loggedIn
        },
        currentTabComponent: function() {
            return this.currentTab
        }
    },
}
</script>

<style scoped>

.tab-button {
    padding: 6px 10px;
    border-radius: 2px;
    border: 1.5px solid #cccccca8;
    cursor: pointer;
    background: #f0f0f08e;
    margin-bottom: 8px;
    margin-right: 8px;
}

.tab-button p{
    color: rgb(175, 175, 175);
}

.tab-button.active p{
    color: #000;
}

.tab-button:hover {
    background: #e0e0e0;
}

.tab-button.active {
    background: #fff;
    border-bottom: 2px solid #000;
    font-weight: bold;
}

.tab {
    border: 1px solid #ccc;
    padding: 10px;
}
</style>